import React from 'react';

import {
  JoinDescription,
  JoinDescriptionId,
} from '@models/feature-descriptor-domain';

import { without } from 'lodash';

export const ExplorationPathJoinList: React.FC<{
  joins: JoinDescription[];
  selectedJoinIds: JoinDescriptionId[];
  setSelectedJoinIds: (ids: JoinDescriptionId[]) => void;
}> = ({ joins, selectedJoinIds, setSelectedJoinIds }) => {
  const isJoinSelected = (join: JoinDescription) =>
    selectedJoinIds.includes(join.joinId);

  function toggleJoinSelection(join: JoinDescription) {
    setSelectedJoinIds(
      isJoinSelected(join)
        ? without(selectedJoinIds, join.joinId)
        : [...selectedJoinIds, join.joinId]
    );
  }

  return (
    <>
      <h4>Joins (# of features)</h4>
      <div style={{ columns: 3 }}>
        {joins.map(join => (
          <div
            key={join.joinId}
            className={`exploration-path-join ${
              isJoinSelected(join) ? 'selected' : ''
            }`}
            onClick={() => toggleJoinSelection(join)}
          >
            [{join.joinId}] {join.description} ({join.numFeatures})
          </div>
        ))}
      </div>
    </>
  );
};
